// extracted by mini-css-extract-plugin
export var deck = "feature-module--deck--mLQSJ";
export var root = "feature-module--root--zPYwS";